import * as types from './mutation-types'

export const loadPerimeterTypes = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/type/perimeters', data).then((response) => {
            commit(types.LOAD_PERIMETER_TYPES, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updatePerimeterType = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/'+ data.id +'/type/perimeter', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createPerimeterType = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/type/perimeter', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deletePerimeterType = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/type/perimeter').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

